import { check50QuestionSheets } from "./api/omrApi";
import BatchOmrPage from "./BatchOmrPage";

export default function Omr50Page() {
  return (
    // <BatchOmrPage
    //   category="OMR 50"
    //   questionCount={50}
    //   endpoint="/api/omr-50/check-batch"
    //   pageDescription=""

    // />
    <BatchOmrPage
      questionCount={50}
      title={"50 OMR"}
      description={""}
      submitFunction={check50QuestionSheets}

    />
  );
}
